const styles = {
  googleBrandContainer: {
    width: 40,
    height: 40,
    borderRadius: 1,
    bgcolor: "grey.100",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontSize: 18,
    fontWeight: 700,
    color: "#4285F4",
  },
};

export default styles;
